import { AuditService } from "../PA.Core/Security/AuditService";

import { PlanManagementBO } from "./PlanManagementBO";
import { auditFieldFK, AuditUtils, IAuditField } from "../PA.Core/Basic/AuditUtils";

export class PlanManagementBOAudit {
    // Audit Log Service for PlanManagement Screen

    static async PlanManagementAuditBO(PlanManagement: PlanManagementBO): Promise<AuditService> {
        const self = PlanManagement;
        const auditService = new AuditService(self.dbContext);

        auditService.setReference("PlanManagement", self.drWB_PlanManagement.cif.WB_PLNMGMT_ID);

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {};
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys;

        // User properties
        const planManagementParams: IAuditField[] = [
            { fieldName: "PLNMGMT_NAME", realName: "Name", bAllMsg: true }, //create
            { fieldName: "PLNMGMT_ID", realName: "ID", bAllMsg: true },
            { fieldName: "WB_CUST_ID_PLANNING", realName: "Planning Customer", ...auditFieldFK.customer },
            { fieldName: "WB_MDSET_ID", realName: "Master Dataset", bAllMsg: true },
            { fieldName: "WB_SALESAREA_ID", realName: "Sales Area", bAllMsg: true },
        ];

        const planManagementPeriodParams: IAuditField[] = [
            { fieldName: "WB_PLANM_ID", realName: "Plan Type", ...auditFieldFK.planType, bAllMsg: true },
            { fieldName: "WB_PERIOD_ID", realName: "Period", ...auditFieldFK.periodNameOnly, bAllMsg: true },
            { fieldName: "WB_PRDGRP_ID", realName: "Planning Level", ...auditFieldFK.productGroup, bAllMsg: true },
        ];

        const planManagementUsrGroupParams: IAuditField[] = [
            { fieldName: "WB_USRGRP_ID", realName: "User Group", ...auditFieldFK.userGroupNameOnly, bAllMsg: true },
            { fieldName: "EFFECTIVE_START_DT", realName: "Start Date" },
            { fieldName: "EFFECTIVE_END_DT", realName: "End Date" },
        ];

        const planManagementUsrParams: IAuditField[] = [
            { fieldName: "WB_AUTHUSR_ID", realName: "User", ...auditFieldFK.user, bAllMsg: true },
            { fieldName: "EFFECTIVE_START_DT", realName: "Start Date" },
            { fieldName: "EFFECTIVE_END_DT", realName: "End Date" },
        ];

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_PlanManagement, planManagementParams, {
            objectName: "Plan Management",
            deletedKeys: deleteKeys,
        });

        for (let aPlnMgmtPeriodRow of self.WB_PlanManagement.WB_PlanManagementPeriodRows) {
            await AuditUtils.logRecord(auditService, aPlnMgmtPeriodRow, planManagementPeriodParams, {
                objectName: "Period",
                deletedKeys: deleteKeys,
            });
        }

        for (let aPlnMgmtUsrGrpRow of self.WB_PlanManagement.WB_PlanManagementUserGroupRows) {
            await AuditUtils.logRecord(auditService, aPlnMgmtUsrGrpRow, planManagementUsrGroupParams, {
                objectName: "User Group Assignment",
                deletedKeys: deleteKeys,
                startDateFieldName: "EFFECTIVE_START_DT",
                endDateFieldName: "EFFECTIVE_END_DT",
            });
        }

        for (let aPlnMgmtUsrRow of self.WB_PlanManagement.WB_PlanManagementUserRows) {
            await AuditUtils.logRecord(auditService, aPlnMgmtUsrRow, planManagementUsrParams, {
                objectName: "User Assignment",
                deletedKeys: deleteKeys,
                startDateFieldName: "EFFECTIVE_START_DT",
                endDateFieldName: "EFFECTIVE_END_DT",
            });
        }

        return auditService;
    }
}
